import React from 'react';

import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import { MODAL_TYPE } from 'constants/modalTypes';
import { useCustomPrivacyPolicySelector } from 'store/privacyPolicy/selectors';
import { setTermsOfServiceModalOpenAction } from 'store/terms_of_use';

import { useTermsModal } from '../Layout/shared/UserMenu/functions';
import s from './index.module.css';
import LocalLegalInfo from './LocalLegalInfo';

function TermsAndConds({ isChecked, toggleCheckbox, actionName }) {
  const dispatch = useDispatch();

  const useCustomPrivacyPolicy = useSelector(useCustomPrivacyPolicySelector);
  const { modal } = useTermsModal();

  return (
    <>
      {useCustomPrivacyPolicy ? (
        <LocalLegalInfo isChecked={isChecked} toggleCheckbox={toggleCheckbox} />
      ) : (
        <div className={cx(s.termsandconds, 'custom-auth-terms-and-cons')}>
          By clicking {actionName}, you accept our{' '}
          <span className="link" onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.PRIVACY_POLICY))}>
            Privacy Policy
          </span>{' '}
          and{' '}
          <span
            className="link"
            onClick={() => dispatch(setTermsOfServiceModalOpenAction(MODAL_TYPE.TERMS_OF_SERVICE))}
          >
            Terms of Service
          </span>
        </div>
      )}
      {modal}
    </>
  );
}

export default TermsAndConds;
